module.exports = __webpack_public_path__ + "img/Isaac.94aea986.jpeg";